import { render } from "./DesignTable.vue?vue&type=template&id=9655c574"
import script from "./DesignTable.vue?vue&type=script&lang=js"
export * from "./DesignTable.vue?vue&type=script&lang=js"

import "./DesignTable.vue?vue&type=style&index=0&id=9655c574&lang=css"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__